import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchListItemStatusLabel'

export default defineMessages({
  pendingApprovalLabel: {
    id: `${scope}.pendingApprovalLabel`,
    defaultMessage: 'Pending approval',
  },
  approvedLabel: {
    id: `${scope}.approvedLabel`,
    defaultMessage: 'Approved',
  },
  deniedLabel: {
    id: `${scope}.deniedLabel`,
    defaultMessage: 'Denied',
  },
  purchasedLabel: {
    id: `${scope}.purchasedLabel`,
    defaultMessage: 'Purchased',
  },
  receivedLabel: {
    id: `${scope}.receivedLabel`,
    defaultMessage: 'Received',
  },
  openLabel: {
    id: `${scope}.openLabel`,
    defaultMessage: 'Open',
  },
  reopenedLabel: {
    id: `${scope}.reopenedLabel`,
    defaultMessage: 'Reopened',
  },
  cancelledLabel: {
    id: `${scope}.cancelledLabel`,
    defaultMessage: 'Cancelled',
  },
  closedLabel: {
    id: `${scope}.closedLabel`,
    defaultMessage: 'Closed',
  },
  paidLabel: {
    id: `${scope}.paidLabel`,
    defaultMessage: 'Paid',
  },
  draftLabel: {
    id: `${scope}.draftLabel`,
    defaultMessage: 'Draft',
  },
  scheduledLabel: {
    id: `${scope}.scheduledLabel`,
    defaultMessage: 'Scheduled',
  },
  processingLabel: {
    id: `${scope}.processingLabel`,
    defaultMessage: 'Processing',
  },
  failedLabel: {
    id: `${scope}.failedLabel`,
    defaultMessage: 'Failed',
  },
  inactiveLabel: {
    id: `${scope}.inactiveLabel`,
    defaultMessage: 'Inactive',
  },
  activeLabel: {
    id: `${scope}.activeLabel`,
    defaultMessage: 'Active',
  },
  expiredLabel: {
    id: `${scope}.expiredLabel`,
    defaultMessage: 'Expired',
  },
  terminatedLabel: {
    id: `${scope}.terminatedLabel`,
    defaultMessage: 'Terminated',
  },
  aiDraftLabel: {
    id: `${scope}.aiDraftLabel`,
    defaultMessage: 'AI Draft',
  },
  aiDraftErrorLabel: {
    id: `${scope}.aiDraftErrorLabel`,
    defaultMessage: 'Processing error',
  },
})
